import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-no-data-message',
  standalone: true,
  imports: [TranslocoPipe, CommonModule],
  templateUrl: './no-data-message.component.html',
  styleUrl: './no-data-message.component.css'
})
export class NoDataMessageComponent {
  @Input() visible = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() header = 'shared.no_data_header';
  @Input() description = 'shared.no_data_desc';

  hideVisible() {
    this.visible = false;
    this.visibleChange.emit(this.visible)
  }
}
